import { create } from 'axios';
import { responseProcessor } from './APIUtil';

const DEV_PORTAL_API = create({
  baseURL: process.env.DEV_PORTAL_API_BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

const API = create({
  baseURL: process.env.API_BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

const ADMIN_API = create({
  baseURL: process.env.ADMIN_API_BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

const ELSA_API = create({
  baseURL: process.env.ELSA_API_BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

const setAccessTokenToHeader = (authToken) => {
  API.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  ADMIN_API.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  ELSA_API.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  DEV_PORTAL_API.defaults.headers.common.Authorization = `Bearer ${authToken}`
};

const setContractIdHeader = (contractId) => {
  DEV_PORTAL_API.defaults.headers.ContractId = contractId
}

DEV_PORTAL_API.interceptors.response.use((response) => {
  response = responseProcessor(response);
  return response;
}, async (error) => {
  if (error.code === 'ECONNABORTED') {
    error.response = responseProcessor({ status: 408 });
  } else {
    error.response = responseProcessor(error.response);
  }
  return Promise.reject(error.response);
});

API.interceptors.response.use((response) => {
  response = responseProcessor(response);
  return response;
}, async (error) => {
  if (error.code === 'ECONNABORTED') {
    error.response = responseProcessor({ status: 408 });
  } else {
    error.response = responseProcessor(error.response);
  }
  return Promise.reject(error.response);
});

ADMIN_API.interceptors.response.use((response) => {
  response = responseProcessor(response);
  return response;
}, async (error) => {
  if (error.code === 'ECONNABORTED') {
    error.response = responseProcessor({ status: 408 });
  } else {
    error.response = responseProcessor(error.response);
  }
  return Promise.reject(error.response);
});

ELSA_API.interceptors.response.use((response) => {
  response = responseProcessor(response);
  return response;
}, async (error) => {
  if (error.code === 'ECONNABORTED') {
    error.response = responseProcessor({ status: 408 });
  } else {
    error.response = responseProcessor(error.response);
  }
  return Promise.reject(error.response);
});

export default {
  DEV_PORTAL_API,
  API,
  ADMIN_API,
  ELSA_API,
  setAccessTokenToHeader,
  setContractIdHeader,
};
